<template>
  <div :class="{ 'trans-section-locked': locked }">
    <div :class="{ completed: completed }"
         class="d-flex align-items-center page-num-container pt-80">
      <div class="page-num">
        <img :src="require('@/assets/images/padlock.svg')"
             alt="padlock"
             class="trans-section-locked-icon" />
      </div>
      <h4 class="trans-section-title">Product Instructions</h4>
    </div>
    <b-row class="trans-section-intro">
      <b-col lg="7">
        <p class="mb-lg-32">
          Detailed instructions need to be taken for each recommendation accepted. Click on each product / service to complete the client instructions.</p>
        <div v-if="locked">
          <p v-if="hasHandedOver"
             class="mb-lg-32">
            This section is currently locked as the transaction has been 'Handed Over'. </p>
          <template v-else>
            <p>
            <span v-if="!previousSectionComplete">This section is currently locked as the previous section is
              incomplete.
            </span>
              <span v-if="!hasTraining">You do not have the relevant permissions to take instructions, please
              email enquiries@dunham-mccarthy.co.uk for more information.</span>
            </p>
          </template>
        </div>
      </b-col>
    </b-row>
    <b-row class="pt-20 trans-section-body">
      <b-col v-for="(will, index) in wills"
             :key="`will${index}`"
             md="4">
        <WillCard :will="will" />
      </b-col>
      <b-col v-for="(lpa, index) in lpas"
             :key="`lpa${index}`"
             md="4">
        <LpaCard :lpa="lpa" />
      </b-col>
      <b-col v-for="(storage, index) in transaction.storages"
             :key="`storage${index}`"
             md="4">
        <StorageCard :storage="storage" :transaction="transaction" />
      </b-col>
    </b-row>

    <Handover v-if="!hasHandedOver && previousSectionComplete && completed"
              :step="handoverStep"
              :transaction="transaction"
              @refreshTransaction="$emit('refreshTransaction', $event)">
      <PostInstructionsHandoverInfo />
    </Handover>
  </div>
</template>

<script>
import WillCard from "./cards/Will";
import LpaCard from "./cards/Lpa";
import Handover from "@/views/introducer/transaction/detail/estatePlanning/models/handover/Handover";
import PostInstructionsHandoverInfo from "@/views/introducer/transaction/detail/estatePlanning/models/handover/PostInstructionsHandoverInfo";
import StorageCard from "@/views/introducer/transaction/detail/estatePlanning/cards/Storage";

export default {
  name: "Products",
  components: {
    StorageCard,
    PostInstructionsHandoverInfo,
    Handover,
    LpaCard,
    WillCard,
  },
  props: {
    lpas: {
      type: Array,
      required: true,
    },
    wills: {
      type: Array,
      required: true,
    },
    previousSectionComplete: {
      type: Boolean,
      required: true,
    },
    transaction: {
      type: Object,
      required: true,
    },
    completed: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      handoverStep: "after_product_instructions",
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    hasTraining() {
      if (this.user) return this.user.is_introducer_training.includes("estate_planning_product_instructions");
      return false;
    },
    hasHandedOver() {
      return !!this.transaction.handover_point;
    },
    locked() {
      return (!this.previousSectionComplete || !this.hasTraining || this.hasHandedOver);
    },
  },
};
</script>
